import script from "./manage-results.vue?vue&type=script&setup=true&lang=js"
export * from "./manage-results.vue?vue&type=script&setup=true&lang=js"

import "./manage-results.vue?vue&type=style&index=0&id=29a02770&lang=scss"

const __exports__ = script;

export default __exports__